import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "article-single__content-editor comment-box" }
const _hoisted_2 = { class: "comment-wrapper" }

import type { ArticleView } from '@/models/doc.article'

import Comments from '@/app/components/community/Comments.vue'
import CommentEdit from '@/app/components/community/CommentEdit.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import { ThreadView } from '@/models/forum'


export default /*@__PURE__*/_defineComponent({
  __name: 'Thread',
  props: {
    article: {}
  },
  setup(__props: any) {

const props = __props

async function updateToggle(value: boolean): Promise<void> {
  await new ThreadView(
    props.article.thread,
    props.article,
  ).toggleNotifyNewComment(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "What do you think?", -1)),
      _createVNode(ToggleButton, {
        class: "discussion-toggle",
        value: __props.article.thread.notify_new_comment,
        "onUpdate:value": updateToggle
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Notify me of new comments in this discussion ", -1)
        ]))]),
        _: 1
      }, 8, ["value"]),
      _createVNode(CommentEdit, {
        ref: "commentEdit",
        doc: __props.article,
        thread: __props.article.thread
      }, null, 8, ["doc", "thread"])
    ]),
    _createVNode(Comments, {
      doc: __props.article,
      thread: __props.article.thread
    }, null, 8, ["doc", "thread"])
  ]))
}
}

})